<template>
  <f7-page>
    <div class="layoutTop"></div>
    <b-container fluid class="main-content homepageBackgroundImage icon-homepage-button-request-document">
      <b-row class="colorOverlay">
      </b-row>
      <b-row class="homepageTextBloc1">
        <b-col sm="12">
          <transition name="slide-fade-title" appear>
            <div class="homepageTitle homepageTitleText">
              MONEYROAD KYC
            </div>
          </transition>
        </b-col>
      </b-row>
      <b-row class="homepageTextBloc2">
        <b-col sm="12">
          <transition name="slide-fade-title" appear>
            <div class="homepageBaseline homepageBaselineText d-flex">
              {{ $t('Homepage.baselineKYC') }}
              <br/>
              {{ $t('Homepage.all2') }}
            </div>
          </transition>
        </b-col>
      </b-row>
      <b-row class="homepageTextBloc3">
        <b-col sm="12">
          <transition name="slide-fade-title" appear>
            <div class="homepageSubTitle homepageSubTitleText">
              <img class="homepageSubTitleLogo" src="./../../assets/static/images/StreamMind_horizontal.png"></img>
            </div>
          </transition>
        </b-col>
      </b-row>
    </b-container>
  </f7-page>
</template>

<script>
import homepageGridLine from '@/components/Homepage/homepageGridLine.vue'
import buttonsData from '@/pages/user/data/homepageData.json'

export default {
  name: 'Homepage',
  components: {
    'homepage-grid-line': homepageGridLine
  },
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  data () {
    return {
      data: buttonsData.buttons
    }
  },
  created () {
    this.$bus.emit('isOnHomepage', true)
    this.$$('.homepageNavbar').removeClass('deleteNavBar')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: '',
      navTitle: '',
      returnUrl: ''
    })
  }
}
</script>
<style scoped>
.colorOverlay {
  background-color: var(--headbandTextColorHover);
  height: 100%;
  opacity: 0.6;
}
.main-content {
  height: calc(100% - 100px);
  overflow-x: hidden;
}
.main-page-positionning {
  margin-top: 44px;
  margin-bottom: 44px;
}
.homepageBackgroundImage {
  background-size: cover;
}
.homepageBaseline {
  display: block !important;
  text-align: center;
  top: 10%;
}
.homepageBaselineText {
  margin-top: 2%;
  font-weight: bolder;
  font-size: 1.2rem;
  line-height: normal;
  color: #ffffff;
}
.homepageSubTitle {
  display: block !important;
  text-align: center;
  top: 10%;
}
.homepageSubTitleText {
  margin-top: 2%;
  font-weight: bolder;
  font-size: 2rem;
  line-height: normal;
  color: #ffffff;
}
.homepageTitle {
  display: block !important;
  text-align: center;
  top: 10%;
}
.homepageTitleText {
  margin-top: 2%;
  font-weight: bolder;
  font-size: 3rem;
  line-height: normal;
  color: #ffffff;
}

@media (min-width:630px) and (max-width:889px) {
  .homepageBaselineText {
    font-size: 1.5rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 4rem;
  }
}
@media (min-width:890px) and (max-width:991px) {
  .homepageBaselineText {
    font-size: 2rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 5rem;
  }
}

@media (min-width:992px) and (max-width:1199px) {
  .homepageBaselineText {
    font-size: 2rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 6rem;
  }
}

@media (min-width:1030px) and (max-width:1199px) {
  .homepageBaselineText {
    font-size: 2rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 7rem;
  }
}
@media (min-width:1200px) {
  .homepageBaselineText {
    font-size: 2.5rem;
  }
  .homepageSubTitleText {
    font-size: 2.5rem;
  }
  .homepageTitleText {
    font-size: 8rem;
  }
}

@media (min-width:992px) {
  .main-page-positionning {
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

.homepageTextBloc1 {
  position: fixed;
  height: 200px;
  margin-top: -100px;
  top: calc(50% + 100px);
  width: 100%;
}

.homepageTextBloc2 {
  position: fixed;
  height: 200px;
  margin-top: -40px;
  top: calc(20% + 100px);
  width: 100%;
}

.homepageTextBloc3 {
  position: fixed;
  height: 200px;
  margin-top: -180px;
  top: calc(90% + 100px);
  width: 100%;
}

@media (max-width:991px) {
  .homepageTextBloc1 {
    top: calc(50% + 44px);
  }
  .homepageTextBloc2 {
    top: calc(20% + 44px);
  }
  .homepageTextBloc3 {
    top: calc(80% + 44px);
  }
  .main-content {
    height: calc(100% - 44px);
  }
}

.homepageSubTitleLogo {
  width: 400px;
}

@media (max-width:450px) {
  .homepageSubTitleLogo {
    width: 350px;
  }
}

.icon-homepage-button-request-document {
  background-image: url('./../../assets/static/images/homepage/request_a_document.png');
}
</style>



// WEBPACK FOOTER //
// HomepageKYC.vue?10a25093